import { BaseModel } from "./base.model";

const MARKET_OBJECT = new Map();
MARKET_OBJECT.set("Root", "Root");
MARKET_OBJECT.set("SendBackToInitiator", "SendBackToInitiator");

export function cleanUp(model) {
  let rootObject = model[model.Root];
  validateObject(rootObject, model);
  console.info("Visited object", MARKET_OBJECT);
  //clearing un-reachable objects
  let unReachableObjects = Object.keys(model).filter(
    (key) => !MARKET_OBJECT.get(key)
  );
  console.warn(`Found following un-reachable object  ==>`, unReachableObjects);
  clearUnreachableObject(unReachableObjects, model);
}

function clearUnreachableObject(unReachableObjectIds, model) {
  unReachableObjectIds.forEach((key) => {
    if (key.startsWith("_")) {
      return;
    }
    console.warn("Removing un-reachable object from model ==> ", key);
    let modelObj = model[key];
    let modelClass = BaseModel.getMetadata(modelObj.Kind);
    let manyToOneList = modelClass.manyToOneList;
    manyToOneList.forEach((refName) => {
      refName = refName.split("::")[0];
      if (modelObj[refName]) {
        let refModelId = modelObj[refName];
        let refObject = model[refModelId];
        if (refObject) {
          let refListKey = `${refName}::${modelObj.Kind}`;
          let refIdList = refObject[refListKey] || [];
          let index = refIdList.indexOf(modelObj.Id);
          if (index > 0) {
            console.warn(
              `Removing orphan manyToOne ref ${refListKey} ${modelObj.Id} from model`,
              refObject
            );
            refIdList.splice(index, 1);
          }
        }
      }
    });
    Reflect.deleteProperty(model, key);
  });
}

function validateChildren(modelObj, model) {
  let modelClass = BaseModel.getMetadata(modelObj.Kind);
  modelClass.oneToManyList.forEach((key) => {
    let children = modelObj[key] || [];
    let orphanChild = [];

    children.forEach((childId) => {
      if (!model[childId]) {
        console.warn(
          `orphan child ${childId} found in model ${modelObj.Kind} ${modelObj.Id}`
        );
        orphanChild.push(childId);
        return;
      }
      validateObject(model[childId], model);
    });
    //removing orphan child ref
    orphanChild.forEach((childId) => {
      children.splice(children.indexOf(childId), 1);
    });
  });
}

export function validateObject(modelObj, model) {
  let modelClass = BaseModel.getMetadata(modelObj.Kind);
  let modelProperties = modelClass.fieldTypes;

  MARKET_OBJECT.set(modelObj.Id, modelObj.Id);

  Object.keys(modelObj).forEach((key) => {
    if (key.includes("::")) {
      if (!modelClass.oneToManyList.includes(key)) {
        let indirectChildList = modelObj[key];
        indirectChildList.forEach((item, index) => {
          if (!model[item]) {
            indirectChildList.splice(index, 1);
          }
        });
      }
      return;
    }
    if (!modelProperties[key]) {
      console.warn(
        `${key} is not a valid property of modal ${modelObj.Kind}, so removing it`
      );
      Reflect.deleteProperty(modelObj, key);
    }
  });

  validateChildren(modelObj, model);
}
